import React from "react";

interface LogoMarkProps {
  size?: number;
  className?: string;
}

export const LogoMark: React.FC<LogoMarkProps> = ({ size = 28, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    <rect width="32" height="32" rx="8" fill="#1c1c1e" />
    <rect x="5" y="7" width="22" height="4" rx="1.5" fill="var(--gold)" />
    <rect x="14" y="11" width="5" height="14" rx="1.5" fill="var(--gold)" />
  </svg>
);
